import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import * as React from "react";
import { Carousel } from "react-responsive-carousel";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import PageLoader from "../../../app/PageLoader";
import { Colors } from "../../../../models/features/Product/Product";
import Lightbox from "react-image-lightbox";
import { useGetCatalogSyncedProductsMutation } from "../../../../redux/reducer/features/Integration/DmsSetupSlice";
import CatalogSyncedProducts from "../../../Edit Product/CatalogSyncedProducts";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
interface ProductDetailProps {
  productData: any;
  stock?: any;
  isOpen: boolean;
  handleClose: any;
  Loading: boolean;
  locations?: any;
  showSyncedProducts?: boolean;
}
const ProductDetail: React.FunctionComponent<ProductDetailProps> = ({
  productData,
  stock,
  isOpen,
  handleClose,
  Loading,
  locations,
  showSyncedProducts,
}) => {
  const [URL, setURL] = React.useState("");
  const [boxOpen, setBoxOpen] = React.useState(false);
  const [openSyncedProducts, setOpenSyncedProducts] = React.useState(false);
  const [syncedProducts, setSyncedProducts] = React.useState<any[]>([]);
  const [getSyncedProductsMutation, getSyncedProductMutationResult] =
    useGetCatalogSyncedProductsMutation();
  const onClose = () => {
    handleClose();
  };

  const handleGetSyncedProducts = () => {
    setOpenSyncedProducts(true);
    getSyncedProductsMutation({ productId: productData?.id ?? "" }).then(
      (res: any) => {
        if (res && res?.data?.status === 0) {
          setSyncedProducts(res?.data?.entityList);
        }
      }
    );
  };

  const handleLightBox = () => {
    setBoxOpen(!boxOpen);
  };
  return (
    <>
      <PageLoader isLoading={Loading}></PageLoader>
      {Loading ? (
        ""
      ) : (
        <Dialog open={isOpen} onClose={onClose} maxWidth="lg" fullWidth>
          <DialogTitle
            sx={{
              padding: "0px",
              paddingTop: "8px",
              paddingLeft: "8px",
              paddingRight: "8px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography fontSize="20px" fontWeight="bold">
              Product Detail
            </Typography>
            <IconButton
              onClick={() => {
                handleClose();
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ height: "70vh" }}>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                color="warning"
                size="small"
                variant="contained"
                onClick={handleGetSyncedProducts}
                sx={{
                  display:
                    showSyncedProducts && productData?.isSynced
                      ? "block"
                      : "none",
                  marginBottom: "10px",
                }}
              >
                Synced Products
              </Button>
            </Box>
            <Grid container spacing={4} justifyContent="flex-start">
              <Grid item xs={12} md={6} pr={2}>
                {productData && productData?.images ? (
                  <Carousel width={"100%"}>
                    {productData?.images.map((img: any) => {
                      return (
                        <div
                          onClick={() => {
                            handleLightBox();
                            setURL(img?.absoluteUrl ?? "");
                          }}
                        >
                          <img
                            style={{ width: "70%" }}
                            src={img?.absoluteUrl ?? ""}
                            alt=""
                          ></img>
                        </div>
                      );
                    })}
                  </Carousel>
                ) : (
                  ""
                )}
              </Grid>
              <Grid
                item
                mt={4}
                xs={12}
                md={6}
                sx={{
                  border: "1px solid #dee2e6 !important",
                  height: "65vh",
                  overflow: "auto",
                }}
              >
                <Typography
                  variant="h5"
                  sx={{ fontWeight: 700, textTransform: "uppercase" }}
                >
                  {productData?.title}
                </Typography>
                <Typography
                  mt={2}
                  mb={3}
                  sx={{
                    textTransform: "uppercase",
                    color: "#6c757d !important",
                    fontSize: 13,
                  }}
                >
                  SEE MORE BY: {productData?.category?.title}
                </Typography>
                <Divider />
                <Typography
                  mt={3}
                  mb={3}
                  sx={{ fontWeight: 600, fontSize: "1.3rem" }}
                >
                  Product Overview
                </Typography>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography sx={{ fontWeight: 700 }}>
                      Description
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      <span
                        dangerouslySetInnerHTML={{
                          __html:
                            productData && productData.description
                              ? productData?.description
                              : "",
                        }}
                      ></span>
                    </Typography>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <Typography sx={{ fontWeight: 700 }}>
                      Weight & Dimension
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Height</TableCell>
                          <TableCell align="right">Weight</TableCell>
                          <TableCell align="right">Width</TableCell>
                          <TableCell align="right">Length</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell component="th" scope="row">
                            {productData?.dimension?.height}{" "}
                            {productData?.dimension?.heightUnit}
                          </TableCell>
                          <TableCell align="right">
                            {productData?.dimension?.weight}{" "}
                            {productData?.dimension?.weightUnit}
                            {productData?.dimension?.weight > 1 && "s"}
                          </TableCell>
                          <TableCell align="right">
                            {productData?.dimension?.width}{" "}
                            {productData?.dimension?.widthUnit}
                          </TableCell>
                          <TableCell align="right">
                            {productData?.dimension?.length}{" "}
                            {productData?.dimension?.lengthUnit}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3a-content"
                    id="panel3a-header"
                  >
                    <Typography sx={{ fontWeight: 700 }}>
                      Specifications
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Table aria-label="customized table">
                      <TableBody>
                        <StyledTableRow>
                          <StyledTableCell>Model Number</StyledTableCell>
                          <StyledTableCell>
                            {productData?.modelNumber}
                          </StyledTableCell>
                        </StyledTableRow>
                        {/* <StyledTableRow>
                          <StyledTableCell>Model Name</StyledTableCell>
                          <StyledTableCell>
                            {productData?.modelName}
                          </StyledTableCell>
                        </StyledTableRow> */}
                        <StyledTableRow>
                          <StyledTableCell>SKU</StyledTableCell>
                          <StyledTableCell>{productData?.sku}</StyledTableCell>
                        </StyledTableRow>

                        <StyledTableRow>
                          <StyledTableCell>Year</StyledTableCell>
                          <StyledTableCell>{productData?.year}</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                          <StyledTableCell>Product Category </StyledTableCell>
                          <StyledTableCell>
                            {productData?.category?.title}
                          </StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                          <StyledTableCell>
                            Product Subcategory{" "}
                          </StyledTableCell>
                          <StyledTableCell></StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                          <StyledTableCell>Power Type </StyledTableCell>
                          <StyledTableCell>
                            {productData?.powerType}
                          </StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                          <StyledTableCell>Color</StyledTableCell>
                          <StyledTableCell>
                            {productData && productData.colors
                              ? productData.colors.map((item: Colors) => (
                                  <Chip label={item.title} />
                                ))
                              : ""}
                          </StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                          <StyledTableCell>Tags</StyledTableCell>
                          <StyledTableCell>
                            {productData && productData.tags
                              ? productData.tags.map((item: any) => (
                                  <Chip label={item} />
                                ))
                              : ""}
                          </StyledTableCell>
                        </StyledTableRow>
                      </TableBody>
                    </Table>
                  </AccordionDetails>
                </Accordion>
                {stock ? (
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography sx={{ fontWeight: 700 }}>stock</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Table aria-label="customized table">
                        <TableHead>
                          <TableRow>
                            <StyledTableCell>Location ID</StyledTableCell>
                            <StyledTableCell>Count</StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {stock.map((row: any) => {
                            var locationName = locations.find(
                              (n: any) => n.DealerId == row.locationId
                            )?.Name;
                            return (
                              <StyledTableRow key={row.LocationId}>
                                <StyledTableCell component="th" scope="row">
                                  {locationName}
                                </StyledTableCell>
                                <StyledTableCell>{row.count}</StyledTableCell>
                              </StyledTableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </AccordionDetails>
                  </Accordion>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </DialogContent>
          {boxOpen && (
            <Lightbox mainSrc={URL} onCloseRequest={handleLightBox} />
          )}
        </Dialog>
      )}
      <CatalogSyncedProducts
        products={syncedProducts}
        isLoading={getSyncedProductMutationResult.isLoading}
        handleClose={() => {
          setOpenSyncedProducts(false);
        }}
        isOpen={openSyncedProducts}
      />
    </>
  );
};
export default ProductDetail;
